<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" class="menu_btn" @click="$router.back()">
                        <img src="@/assets/common/hd_prev_btn.png" alt="" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <p class="page_title2">
                    <b>개인정보</b>에 <br> 동의해주세요!
                </p>
                <form action="#n" method="post" id="user_form">
                    <div class="private_box">
                        <div class="private_txt">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                            been the industry's standard dummy text ever since the 1500s, when an unknown printer took a
                            galley of type and scrambled it to make a type specimen book. It has survived not only five
                            centuries, but also the leap into electronic typesetting, remaining essentially unchanged.
                            It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum
                            passages, and more recently with desktop publishing software like Aldus PageMaker including
                            versions of Lorem Ipsum.
                        </div>
                        <label class="checkbox" for="check">
                            <input type="checkbox" name="" id="check" v-model="state.checkAgree">
                            <b></b>
                            <span>개인정보 동의</span>
                        </label>
                    </div>
                    <button type="submit" id="submit_btn" @click="joinPage"><img src="@/assets/common/write_ico.png"
                            alt="">회원가입</button>
                    <p class="check_form_info">관리자 승인 이후 서비스 이용이 가능합니다.</p>
                </form>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose"> </ModalComponent>
</template>
<script lang="ts" config>
import {
    HeaderLayout,
    GnbLayout,
    router,
    reactive,
    ModalComponent,
} from "@/BaseComponent";

export default {
    components: {
        HeaderLayout,
        GnbLayout,
        ModalComponent,
    },
    setup() {
        const state = reactive({
            checkAgree: false as boolean,
            isModalOpen: false as boolean,
        });

        const modal = reactive({
            content: "" as string,
            confirm: "" as string,
            cancel: "" as string,
        });

        const joinPage = (e: Event) => {
            e.preventDefault();
            if (state.checkAgree === true) {
                router.replace('/joinTest');
            } else {
                modal.content = "개인정보 동의를 체크해주세요";
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
        };
        return {
            state,
            modal,
            router,
            joinPage,
            modalClose
        };
    },
};
</script>
